export const LineChartXAxisLabel = ({
  x,
  y,
  label,
  textAnchor,
}: {
  x: any;
  y: any;
  textAnchor: 'start' | 'middle' | 'end' | 'inherit' | undefined;
  label: string | undefined;
}) => {
  return (
    <text
      x={x}
      y={y}
      textAnchor={textAnchor}
      fontSize={11}
      fontWeight={400}
      fontFamily={'-apple-system, BlinkMacSystemFont, system-ui, sans-serif'}
      className="!fill-white"
    >
      {label}
    </text>
  );
};
